module.exports = __webpack_public_path__ + "img/information-vector-icon.2817ddae.jpg";